import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Profile {
  id: string;
  name: string;
  currentOrg: string;
  organizations: Organization[];
}

export interface UpdateProfileRequest {
  name: string;
  currentOrg: string;
}

export interface NotifyWindow {
  start: string;
  end: string;
  timeZone: string;
}

export interface AlertConfig {
  subjectLabel: string;
  subjectLabelPlural: string;
  retryAttempts: number;
  retryIntervalMinutes: number;
  smsBody: string;
  pressZeroToConnect: boolean;
  urlTitle: string;
  urlHyperlink: string;
  notifyWindow: NotifyWindow;
  targetTime?: string;
  noText?: boolean;
  noCall?: boolean;
}

export interface Organization {
  id: string;
  description: string;
  patientsCount: number;
  locationsCount?: number;
  alertConfig?: AlertConfig;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  #http = inject(HttpClient);

  /**
   * Retrieves the user's profile information.
   *
   * @returns {Observable<Profile>} An observable containing the user's profile data.
   */
  getProfile(): Observable<Profile> {
    return this.#http.get<Profile>(`${environment.urls.standaloneApi}/v1/user/profile`);
  }

  /**
   * Updates the user's profile with the provided information.
   *
   * @param request - An object containing the updated profile information.
   * @returns An Observable that completes when the profile update is successful.
   */
  updateProfile(request: UpdateProfileRequest): Observable<void> {
    return this.#http.put<void>(`${environment.urls.standaloneApi}/v1/user/profile`, {
      ...request,
    });
  }
}
